// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qaMJGaFjwlPkXc {
  vertical-align: text-top;
}
.ynXsALMvTdWNSH {
  margin: 8px var(--ds-space-0, 0);
}
.we0Z8HnUw3En3y {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin: 4px var(--ds-space-0, 0);
}
.SUi38lmySugH4l {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}
.SUi38lmySugH4l .LIQVglj_0ssHWx {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin-right: 4px;
}
`, ""]);
// Exports
export var headerIcon = `qaMJGaFjwlPkXc`;
export var divider = `ynXsALMvTdWNSH`;
export var button = `we0Z8HnUw3En3y`;
export var feedbackButton = `SUi38lmySugH4l`;
export var feedbackIcon = `LIQVglj_0ssHWx`;
export default ___CSS_LOADER_EXPORT___;
